import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Image, Modal, Tab, Tabs } from "react-bootstrap";
import illusEspaces from "../../../assets/images/illusEspaces.jpg";
import { MdLocationOn, MdOutlineEdit, MdOutlineWorkspaces } from "react-icons/md";
import { GrGroup } from "react-icons/gr";
import { usagesSalles } from "../../../constants/usagesSalles";
import { usagesDigital } from "../../../constants/usagesDigital";
import ComponentCalendrier from "./ComponentCalendrier";
import ModalSpaces from "../../admin/localisation/ModalSpaces";
import { useSelector } from "react-redux";
import ComponentLoader from "../../layout/ComponentLoader";
import QRCode from "react-qr-code";

const ModalDetailSpace = (props) => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const { espace, show, calendrier, handleClose, usagesDisponibles } = props;
  const [showEditSpace, setShowEditSpace] = useState(false);
  const [loader, setLoader] = useState(true);

  const usesSalles = usagesSalles;
  const usesDigital = usagesDigital;

  const pointCouleur = (usages, usage, withUsage = null) => {
    let usageTrouve = usages.filter((item) => item.tag === usage)[0];

    if (usageTrouve)
      return (
        <React.Fragment key={usage}>
          <span className="pointCouleurUsage" style={{ backgroundColor: usageTrouve.color }}></span>
          {withUsage !== null ? withUsage : ""}
        </React.Fragment>
      );

    return null;
  };

  const handleCloseEditMode = () => {
    setShowEditSpace(false);
    handleClose();
  };

  const AfficheUsage = ({ idUsage = null }) => {
    if (idUsage) {
      let usagePrincipalTrouve = usagesDisponibles.filter((item) => item._id === idUsage);
      if (usagePrincipalTrouve && usagePrincipalTrouve.length > 0)
        return <div>{usagePrincipalTrouve[0].nom}</div>;
    }
    return null;
  };

  /* UTILE POUR LES ADMINISTRATEURS */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const BoutonReservationEnAttendant = (emailResponsable) => {
    return ReduxInstance.urlReservationSalle ? (
      emailResponsable ? (
        <div className="mt-3 text-center">
          <Button
            href={
              "mailto:" +
              espace.emailResponsable +
              "?Subject=Demande de réservation de la salle : " +
              espace.nom
            }
            rel="noreferrer"
          >
            {t("public.boutons.je_commande")}
          </Button>
        </div>
      ) : (
        <div className="mt-3 text-center">
          <Button href={ReduxInstance.urlReservationSalle} target="_blank" rel="noreferrer">
            {t("public.boutons.je_reserve")}
          </Button>
        </div>
      )
    ) : (
      ""
    );
  };

  useEffect(() => {
    if (show) setLoader(true);
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const qrCodeDisponibilites = () => {
    let urlEspace =
      process.env.REACT_APP_URL_EASYGOUV +
      "choixInstance?instance=" +
      ReduxInstance._id +
      "&page=espaces" +
      "&popup=" +
      espace._id;
    return urlEspace;
  };

  return (
    <>
      {show && (
        <>
          <Modal
            size="lg"
            show={show && !showEditSpace}
            onHide={handleClose}
            className="modalDetailSpace"
          >
            <Modal.Header closeButton>
              <Modal.Title>{t("public.pageTierslieux.titleColonne5")}</Modal.Title>
              {isAdminEasygouv() && (
                <div className="flex-grow-1 text-end">
                  <MdOutlineEdit
                    size="1.5em"
                    role="button"
                    onClick={() => setShowEditSpace(true)}
                    className=""
                  />
                </div>
              )}
            </Modal.Header>
            <Modal.Body className="whiteSpace">
              <div className="d-flex flex-wrap justify-content-center">
                <Image
                  className="roomBig"
                  src={
                    espace.cardPic
                      ? process.env.REACT_APP_URL_EXPRESS + "images/space/" + espace.cardPic
                      : illusEspaces
                  }
                />
                <span className="flex-grow-1 p-2">
                  <h2>{espace.nom}</h2>

                  <p className="d-flex">
                    <MdLocationOn size="1.5em" className="me-1" />
                    <span>
                      {espace.localisation.nom ? espace.localisation.nom : "-"} <br />
                      {espace.zone ? (
                        <>
                          {espace.zone}
                          <br />
                        </>
                      ) : (
                        ""
                      )}
                      {espace.localisation.adresse ? espace.localisation.adresse : ""}
                    </span>
                  </p>

                  <p>
                    <GrGroup size="1.5em" className="me-1" />
                    {espace.capacite
                      ? espace.capacite === 1
                        ? espace.capacite + " " + t("public.pageTierslieux.personne")
                        : espace.capacite + " " + t("public.pageTierslieux.personnes")
                      : "-"}
                  </p>
                </span>
              </div>
              <div className="mt-3">
                <Tabs defaultActiveKey={espace.email ? "calendrier" : "usages"} className="mb-3 ">
                  <Tab eventKey="usages" title={t("public.pageTierslieux.titleColonne3")}>
                    {espace.usages.map((idUsage, index) => (
                      <AfficheUsage key={idUsage} idUsage={idUsage} />
                    ))}

                    {espace.mainUse !== "null" && espace.mainUse ? (
                      <div>
                        {/* {pointCouleur(usesSalles, espace.mainUse)} */}
                        {t("commun.usagesSalles." + espace.mainUse)}
                      </div>
                    ) : (
                      ""
                    )}
                    {espace.secondaryUses.sort().map((use, index) => {
                      return (
                        <div key={"secondaryUse" + index}>
                          {/* {pointCouleur(usesSalles, use)} */}
                          {t("commun.usagesSalles." + use)}
                        </div>
                      );
                    })}

                    {espace.agencements.length > 0 && (
                      <>
                        <hr />
                        <span className="fw-bold">{t("public.pageTierslieux.titleColonne6")}</span>
                        <br />
                        <div className="d-flex flex-wrap justify-content-around">
                          {espace.agencements.map((photoName, index) => (
                            <Image
                              className="m-1 p-1"
                              key={"photoAgencement_" + index}
                              width={300}
                              height={169}
                              src={process.env.REACT_APP_URL_EXPRESS + "images/space/" + photoName}
                            />
                          ))}
                        </div>
                      </>
                    )}
                  </Tab>

                  <Tab eventKey="connectivite" title={t("public.pageTierslieux.titleColonne7")}>
                    {espace.mainUseDigital !== "null" && espace.mainUseDigital ? (
                      <div>
                        {/* {pointCouleur(usesDigital, espace.mainUseDigital)} */}
                        {t("commun.usagesDigital." + espace.mainUseDigital)}
                      </div>
                    ) : (
                      ""
                    )}
                    {espace.secondaryUsesDigital.sort().map((use, index) => {
                      return (
                        <div key={"secondaryUseDigital" + index}>
                          {/* {pointCouleur(usesDigital, use)} */}
                          {t("commun.usagesDigital." + use)}
                        </div>
                      );
                    })}

                    {espace.procedure && (
                      <>
                        <hr />
                        <span className="fw-bold">{t("public.pageTierslieux.titleColonne4")}</span>
                        <br />
                        {espace.procedure}
                      </>
                    )}
                  </Tab>

                  {espace.email && (
                    <tab eventKey="calendrier" title={t("public.pageTierslieux.calendrier")}>
                      {calendrier ? (
                        <ComponentCalendrier
                          calendrier={calendrier}
                          emailResponsable={espace.emailResponsable}
                          nomSalle={espace.nom}
                        />
                      ) : (
                        BoutonReservationEnAttendant(espace.emailResponsable)
                      )}
                    </tab>
                  )}

                  {espace.email && (
                    <tab
                      eventKey="qrCodeDisponibilites"
                      title={t("public.pageTierslieux.qrCodeDisponibilites")}
                      className="text-center"
                    >
                      <QRCode value={qrCodeDisponibilites()} className="m-2" size={200} />
                      <br />

                      {t("public.pageTierslieux.qrCodeDisponibilitesExplications")}
                    </tab>
                  )}
                </Tabs>
              </div>
            </Modal.Body>
          </Modal>
          <ModalSpaces
            show={showEditSpace}
            id={espace.localisation._id}
            handleClose={handleCloseEditMode}
            editModeForceSpace={espace}
          />
        </>
      )}
    </>
  );
};

export default ModalDetailSpace;
